import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const FAQS = [
  {
    q: "Is paper trading available now? Is it free?",
    a: "Yes — paper trading is available now and is fully free with virtual funds. All market data is synced in real-time, so you can test strategies under actual market conditions without using real money.",
  },
  {
    q: "Can I track top-tier investors like Warren Buffett?",
    a: "Yes. FinX lets you mirror Warren Buffett, Nancy Pelosi, Cathie Wood and more in real time. View holdings, allocations across industries, and follow their moves.",
  },
  {
    q: "What is Fifi, and how does she help me invest?",
    a: "Fifi is FinX's gamified AI advisor — a fine-tuned financial LLM that uses chain-of-thought reasoning to deliver portfolio checks, hold/sell reviews, risk alerts, and quant signals. She also grows with your XP as you learn.",
  },
  {
    q: "Can I use simulation to validate Fifi's predictions?",
    a: "Fifi's Quant Agent features and predictions are still in development and have not fully launched yet. We recommend starting with our mock trading simulator to practice managing positions, refine your strategies, and build trading intuition while we finish training Fifi.",
  },
  {
    q: "How do I move from paper trading to live trading?",
    a: "Paper trading is available now with virtual funds. Live trading is planned for November 2026 and is not yet available. Join our waitlist to be notified when live trading launches — early access will be offered to waitlist members first.",
  },
  {
    id: "pawfolio",
    q: "What is PawFolio, and can I use it through this website?",
    a: "PawFolio is FinX's digital investment advisory technology. It uses a 10-question investor profile, rules-based risk assessment, and investment themes to generate model portfolios with holdings, target allocations, and explanations. Its current implementation uses simulated accounts, not live trading or funded-account management. This website provides an informational overview only: it does not offer access to PawFolio, collect investment-profile answers, or provide portfolio recommendations. FinX's general waitlist is not PawFolio enrollment.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#FFEDD5] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-[#9A3412]">
            <HelpCircle size={14} /> Answers
          </span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl font-black tracking-tighter text-slate-900">
            Got questions?
            <br />
            <span className="brand-gradient-text">We've got answers.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${item.id ?? i}`}
              className="bg-white rounded-2xl border border-slate-100 px-6 data-[state=open]:border-[#A855F7]/30 transition-colors"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${item.id ?? i}`}
                className="text-left font-display font-bold text-slate-900 hover:no-underline py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${item.id ?? i}`} className="text-slate-600 leading-relaxed pb-5 text-base">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
